import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  getCrmCodeList: (params: CrmCodeListReqDto): Promise<CrmCodeListResDto> =>
    request({
      url: endpoints.crm.code,
      method: 'get',
      params,
    }),  
  postCrmList: (params: CrmListReqDto): Promise<CrmListResDto> =>
    request({
      url: endpoints.crm.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCrmInfo: (params: CommonIdReqDto): Promise<CrmInfoResDto> =>
    request({
      url: endpoints.crm.info,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCrmAdd: (params: CrmSaveReqDto): Promise<CrmInsertResDto> =>
    request({
      url: endpoints.crm.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCrmUpdate: (params: CrmSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.crm.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCrmDelete: (params: CommonIdReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.crm.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postCrmAppCheck: (params: CrmAppCheckReqDto): Promise<CrmAppCheckResDto> =>
    request({
      url: endpoints.crm.app_check,
      method: 'post',
      data: paramsToFormData(params),
    }),
};
